import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { CommunitySection } from './components/CommunitySection';
import { VisionSection } from './components/VisionSection';
import { ManifestoSection } from './components/ManifestoSection';
import { FinalCTA } from './components/FinalCTA';
import { EventsPage } from './components/EventsPage';
import { Footer } from './components/Footer';
function ScrollToHash() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      // Wait for the target route to render before scrolling
      const timeout = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 100);
      return () => clearTimeout(timeout);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}
function HomePage() {
  return <main data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <CommunitySection data-id="element-4" />
      <VisionSection data-id="element-5" />
      <ManifestoSection data-id="element-6" />
      <FinalCTA data-id="element-7" />
    </main>;
}
export function App() {
  return <BrowserRouter data-id="element-8">
      <ScrollToHash data-id="element-9" />
      <div className="min-h-screen bg-cream selection:bg-marigold selection:text-navy" data-id="element-10">
        <Navigation data-id="element-11" />
        <Routes data-id="element-12">
          <Route path="/" element={<HomePage data-id="element-14" />} data-id="element-13" />
          <Route path="/events" element={<EventsPage data-id="element-16" />} data-id="element-15" />
        </Routes>
        <Footer data-id="element-17" />
      </div>
    </BrowserRouter>;
}